<template>
  <div class="grid grid-cols-6 xl:grid-cols-12 gap-4 max-w-6xl mx-auto py-6 px-1">

    <!-- Transfer info -->
    <div class="col-span-full xl:col-span-8">
      <div class="col-span-full mt-2 mb-5">
        <h4 class="text-xl font-bold text-surface-600 antialiased">
          {{ $t('pages.admin.assets.asset_transfers.asset_transfer.properties.asset_transfer_properties_view.asset_transfer_data') }}
        </h4>
      </div>

      <Card>
        <template #content>
          <DescriptionList :title="$t('common.information')" class="-mt-6">
            <DescriptionListItem
              :term="$t('pages.admin.assets.asset_transfers.asset_transfer.properties.asset_transfer_properties_view.asset_name')"
              :details="transfer.asset?.name ?? '-'"
            />
            <DescriptionListItem
              :term="$t('pages.admin.assets.asset_transfers.asset_transfer.properties.asset_transfer_properties_view.pre_owner')"
              :details="transfer.pre_owner?.name ?? $t('common.public')"
            />
            <DescriptionListItem
              :term="$t('pages.admin.assets.asset_transfers.asset_transfer.properties.asset_transfer_properties_view.current_owner')"
              :details="transfer.current_owner?.name ?? $t('common.public')"
            />
            <DescriptionListItem
              :term="$t('pages.admin.assets.asset_transfers.asset_transfer.properties.asset_transfer_properties_view.notes')"
              :truncated="false"
            >
              <span class="whitespace-pre-line">
                {{ transfer.notes ?? '-' }}
              </span>
            </DescriptionListItem>
          </DescriptionList>
        </template>
      </Card>
    </div>

    <!-- Devices -->
    <div class="col-span-full xl:col-span-8 mt-8">
      <div class="col-span-full mt-2 mb-5">
        <h4 class="text-xl font-bold text-surface-600 antialiased">
          {{ $t('pages.admin.assets.asset_transfers.asset_transfer.properties.asset_transfer_properties_view.devices_transferred_with_the_asset') }}
        </h4>
      </div>

      <Card>
        <template #content>
          <div class="-mt-6">
            <div v-if="transfer.asset?.devices?.length" class="text-sm text-surface-900 dark:text-surface-200">
              <ul class="divide-y divide-surface-200 dark:divide-surface-700">
                <li v-for="d in transfer.asset.devices" :key="d.id" class="py-2 flex items-start justify-between gap-3">
                  <span class="font-medium">
                    {{ d.serial_number ?? d.id }}
                  </span>
                  <span class="text-surface-500 dark:text-surface-400">
                    {{ d.device_type?.name ?? d.device_type?.key ?? '-' }}
                  </span>
                </li>
              </ul>
            </div>

            <div v-else class="text-sm text-surface-900 dark:text-surface-200">-</div>
          </div>
        </template>
      </Card>
    </div>

  </div>
</template>

<script>
import DescriptionList from "@/Components/DescriptionList.vue";
import DescriptionListItem from "@/Components/DescriptionListItem.vue";

export default {
  name: 'AssetTransferPropertiesView',
  components: {
    DescriptionList,
    DescriptionListItem,
  },
  props: {
    transfer: { type: Object, required: true }
  },
}
</script>

<style scoped>
</style>
